import "./App.css";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { IpodLayout } from "./Layouts/Ipod/IpodLayout.js";
import { PlaylistScreen } from "./Screens/PlaylistScreen/PlaylistScreen.js";
import { QueueProvider } from "./Context/QueueProvider.tsx";
import { PlayerRefProvider } from "./Context/PlayerRefProvider.tsx";
import BlockBrowsers from "./Components/BlockBrowsers.js";
import { PlaylistBuilderScreen } from "./Screens/PlaylistBuilder/PlaylistBuilder.js";
import { colors } from "./styles/theme.js";
import { authenticateAdmin } from "./Api/PocketbaseClient.js";
import { MountTimestampProvider } from "./Context/MountTimestampProvider.tsx";
import { SystemStatusProvider } from "./Context/SystemStatusProvider.tsx";
import { SystemStatusAlert } from "./Components/SystemStatusAlert.js";

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>Welcome to YouTube Auto DJ!</h2>
        <p>
          Please provide a playlist ID in the URL to start playing your
          playlist.
          <br />
          Example: <code>?playlistId=YOUR_PLAYLIST_ID</code>
        </p>
      </header>
    </div>
  );
}

function App() {
  const firstLoad = useRef(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (!firstLoad.current) {
      authenticateAdmin()
        .then((res) => {
          console.log("Admin authentication response:", res);
          setIsAuthenticated(true);
          firstLoad.current = new Date().getTime();
        })
        .catch((error) => {
          console.error("Failed to authenticate PocketBase admin:", error);
        });
    }
  }, []);

  if (!isAuthenticated) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{
        backgroundColor: colors.background,
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <SystemStatusProvider>
        <MountTimestampProvider>
          <QueueProvider>
            <PlayerRefProvider>
              <Router>
                <Routes>
                  {/* <Route path="/admin" element={<AdminConsole />} /> */}
                  <Route path="/" element={<Home />} />
                  <Route
                    path="/ipod"
                    element={<IpodLayout firstLoad={firstLoad} />}
                  />
                  <Route
                    path="/playlist"
                    element={
                      <BlockBrowsers blockedBrowsers={["SecondLife"]}>
                        <SystemStatusAlert>
                          <PlaylistScreen />
                        </SystemStatusAlert>
                      </BlockBrowsers>
                    }
                  />
                  <Route
                    path="/user-playlist/:connectionId"
                    element={
                      <SystemStatusAlert>
                        <PlaylistBuilderScreen />
                      </SystemStatusAlert>
                    }
                  />
                </Routes>
              </Router>
            </PlayerRefProvider>
          </QueueProvider>
        </MountTimestampProvider>
      </SystemStatusProvider>
    </div>
  );
}

export default App;
